import { fetchAverageDaysCompletion } from '@/api/ave-days-completion-api'
import { ChartDataItem, UseAverageDaysCompletionParams, UseAverageDaysCompletionReturn } from '@/utilities/types/average.types'
import { useCallback, useEffect, useState } from 'react'

export const useAverageDaysCompletion = ({
  year,
  sinceDate,
  untilDate,
}: UseAverageDaysCompletionParams = {}): UseAverageDaysCompletionReturn => {
  const [data, setData] = useState<ChartDataItem[]>([])

  const fetchData = useCallback(async () => {
    try {
      const userId = localStorage.getItem('userId')
      const roleString = localStorage.getItem('role')

      if (!userId) {
        throw new Error('User ID not found in localStorage')
      }
      const roleName = roleString ? JSON.parse(roleString) : undefined
      console.log('Fetching average days completion with params:', { userId, roleName, year, sinceDate, untilDate });

      const result = await fetchAverageDaysCompletion({
        userId,
        roleName,
        year,
        sinceDate,
        untilDate,
      })

      const chartData = result.map((item) => ({
        label: item.type_of_concern,
        value: item.average_days_completion,
        ticketCount: item.no_of_ticket_completed,
      }))
      const hasValidData = chartData.some(item => item.value > 0)
      setData(hasValidData ? chartData : [])
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to fetch completion data')
      console.error('Failed to fetch completion data:', error)
      setData([])
    }
  }, [year, sinceDate, untilDate])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data }
}